import auth from "./auth";
import api from "./api";

const SERVICE_URL = "design-service/news/";

export default {
    getNewsDetails(uuid) {
        return new Promise((resolve, reject) => {
            api.get(`${SERVICE_URL}view/${uuid}`, auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    createNews(payload) {
        return new Promise((resolve, reject) => {
            api.post(`${SERVICE_URL}create`, payload, auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    updateNews(payload) {
        return new Promise((resolve, reject) => {
            api.post(`${SERVICE_URL}update/${payload.uuid}`, payload, auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    getNewsList(status) {
        return new Promise((resolve, reject) => {
            api.get(`${SERVICE_URL}list/${status}`, auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    deleteNews(uuid) {
        return new Promise((resolve, reject) => {
            api.delete(`${SERVICE_URL}delete/${uuid}`, auth.getHeader())
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    }
};
